import { supabase } from '@/lib/supabase';
import type { Database, PaletteColorRow } from '@/types/database';

type PaletteInsert = Database['public']['Tables']['palette_colors']['Insert'];
type PaletteUpdate = Database['public']['Tables']['palette_colors']['Update'];

/**
 * Every ROOM color in a project, for the presentation export (2026-09-22).
 *
 * Replaces listPalette(), which read the project-level colors — rows with no
 * room. Those were retired with 0044: a color belongs to a room, chosen in
 * that room. Old rows are still in the table as the rollback path, and this
 * deliberately does not return them.
 */
export async function listProjectRoomColors(projectId: string): Promise<PaletteColorRow[]> {
  const { data, error } = await supabase
    .from('palette_colors')
    .select('*')
    .eq('project_id', projectId)
    .not('room_id', 'is', null)
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function listRoomPalette(roomId: string): Promise<PaletteColorRow[]> {
  const { data, error } = await supabase
    .from('palette_colors')
    .select('*')
    .eq('room_id', roomId)
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function createPaletteColor(input: PaletteInsert): Promise<PaletteColorRow> {
  const { data, error } = await supabase.from('palette_colors').insert(input).select().single();
  if (error) throw error;
  return data;
}

export async function updatePaletteColor(id: string, patch: PaletteUpdate): Promise<PaletteColorRow> {
  const { data, error } = await supabase.from('palette_colors').update(patch).eq('id', id).select().single();
  if (error) throw error;
  return data;
}

export async function deletePaletteColor(id: string): Promise<void> {
  const { error } = await supabase.from('palette_colors').delete().eq('id', id);
  if (error) throw error;
}
